module.exports = __webpack_public_path__ + "static/media/archive.6ad37a59.svg";